import { lazy, Suspense, useEffect } from 'react';

import useAppSelector from '~hooks/useAppSelector';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import { selectAddonsIsFontOrderEnabled } from '~store/selectors';

const FontOrderExtension = lazy(() => import('~extension/font-order/FontOrder'));

export const FontOrderPage = () => {
  const navigateToDefault = useNavigateToDefault();

  const isEnabled = useAppSelector(selectAddonsIsFontOrderEnabled);

  useEffect(() => {
    if (!isEnabled) {
      navigateToDefault();
    }
  }, [navigateToDefault, isEnabled]);

  return (
    <div className="c-view__content relative flex-grow overflow-hidden">
      <div className="h-full">
        <Suspense fallback="loading">
          <FontOrderExtension />
        </Suspense>
      </div>
    </div>
  );
};
